<template lang="pug">
  .footer
    span.info-terms *APLICA SOLO PARA REGISTROS MERCANTIL Y ENTIDADES SIN ANIMO DE LUCRO
    a.terms-btn(href='/docs/terms_2020.pdf', target='_blank') TERMINOS Y CONDICIONES    
    span.copy 2020
</template>

<script>
export default {
}
</script>

<style lang="sass" scoped>
  .dev
    text-align: center
    z-index: 2
  .footer
    background: transparent
    position: relative
    width: 100%
    display: flex
    flex-direction: column
    align-items: center
    color: #5F669C
    padding-top: 2rem
    padding-bottom: 4rem
    //transform: skewY(5deg)
    &:after, &:before
      width: 50vw
      height: 400px
      position: absolute
      background-size: contain !important
      background-repeat: no-repeat !important
      background-position: bottom right !important
      z-index: -1
    &:before
      content: ''
      background-image: url(../../../images/assets2020/curva-ultima-01.svg)
      bottom: 0px
      right: 0px
      //transform: rotate(157deg)
  .players
  .info-terms
    font-family: "Montserrat-LightItalic"
    font-weight: 300
    font-size: 1rem
    text-align: center
  a
    margin-bottom: 20px
    display: inline-block
    color: #5F669C
    font-weight: bold
  .copy
    font-family: "Montserrat-Italic"
    font-size: 30px
    font-weight: 600
  .terms-btn
    font-family: "Montserrat-BlackItalic"
    margin: 6px 0 9px 0
    text-align: center
    background-image: linear-gradient(to right, #07b987 , #9eb237)
    border: 0
    letter-spacing: 1px
    font-size: 20px
    padding: 9px 15px
    font-weight: 900
    color: #fff
    border-radius: 15px
    outline: none
</style>



// WEBPACK FOOTER //
// resources/js/components/PageConcurso2020/FooterMatricula.vue